import Rest from "../../../class/tool/Rest";
import BackgroundTask from "./BackgroundTask";

class BackgroundTaskController {
    #_rest = new Rest();
    _callback = null;
    _baseURL = "tasks";

    index() {
        this.#_rest.sendQuery(
            'GET',
            '/' + this._baseURL,
            {},
            this.handleIndex);
    }
    handleIndex = (response, error, status = 200) => {
        let listObjects = [];

        if(status === 200) {
            const datas = response.data;
            const keys = Object.keys(datas);
            let model;

            for (let i in keys) {
                switch (keys[i]) {
                    case "mainLicenseChangingProcess":
                    case "resetProcess":
                        listObjects.push(new BackgroundTask({
                            "type": keys[i],
                            "state": datas[keys[i]]
                        }));
                        break;
                    default:
                        model = datas[keys[i]] !== null ? datas[keys[i]] : {};
                        model.type = keys[i];
                        listObjects.push(new BackgroundTask(model));
                        break;
                }
            }
        }

        if (this._callback !== null)
            this._callback(listObjects, error, status)
    }
}

export default BackgroundTaskController;